<div class="div-display">
  <img alt="" style="width: 2.25rem; max-height: 1.75rem; margin-right: 0.5rem;" *ngIf="img_url" [src]="img_url | company">
  <strong>
    {{ title | translate }}:
  </strong>
  <p class="mt-0 mb-0 ml-3">
    {{ pastTime }}
  </p>
</div>